<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<div class="pageTit">
			<span>员工管理</span>
		</div>
		<!-- 筛选 -->
		<div class="shaixuan f-bct">
			<div class="l f-ct">
				<div class="itm">
					<span>加入时间</span>
					<el-date-picker
					v-model="value1"
					value-format="yyyy-MM-dd"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
					</el-date-picker>
				</div>
				<div class="itm">
					<span>关键词</span>
					<el-input type="text" v-model="keword" placeholder="请输入搜索关键词"></el-input>
				</div>
				<div class="seachBtn f-ct">
					<div @click="membermemberList(1)">搜索</div>
					<div @click="value1='',keword='',membermemberList(1)">重置</div>
				</div>
			</div>
			<div class="seachBtn2 f-ct">
				<!-- <div @click="hbExcel=true">Excel导入</div> -->
				<div @click="hbAddStaff=true">添加员工</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="biaoge">
			<div class="zw" v-if="!kpxxList.length">
				<el-image :src="require('@/static/zw.png')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			<div class="table" v-if="kpxxList.length">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">申请类目</p>
					<p class="t3">姓名</p>
					<p class="t4">性别</p>
					<p class="t5">身份证号码</p>
					<p class="t6">联系方式</p>
					<p class="t7">加入时间</p>
					<p class="t9">用户状态</p>
					<p class="t8">操作</p>
				</div>
				<div class="td f-ct" v-for="(item,index) in kpxxList">
					<p class="t1">{{item.id}}</p>
					<p class="t2">{{item.courseCategoryName}}</p>
					<p class="t3">{{item.name}}</p>
					<p class="t4" v-if="item.gender==0">未知</p>
					<p class="t4" v-if="item.gender==1">男</p>
					<p class="t4" v-if="item.gender==2">女</p>
					<p class="t5">{{item.identityCardCode}}</p>
					<p class="t6">{{item.mobile}}</p>
					<p class="t7">{{item.createTime}}</p>
					
					<p class="t9" v-if="item.auditStatus==0">审核中</p>
					<p class="t9" v-if="item.auditStatus==1">审核通过</p>
					<p class="t9" v-if="item.auditStatus==2">
						<el-tooltip class="item" effect="dark" :content="item.auditInfo+''" placement="top">
						<p style="color: red;">审核不通过</p>
						</el-tooltip>
					</p>
					
					<p class="t8 blue" @click="hbPwd=true,memberId=item.id">修改密码</p>
				</div>
			</div>
			<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>
		</div>
		</div>
		<!-- 弹出框 修改密码 -->
		<div class="maskBg" @click="hbPwd=false" v-if="hbPwd"></div>
		<div class="subTips" v-if="hbPwd">
			<div class="hbTit f-bct">
				<p>修改密码</p>
				<el-image class="cha" @click="hbPwd=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="iptBox">
				<div class="lable">输入新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="password" placeholder="请输入新密码"></el-input>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">确认新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="confirmPassword" placeholder="请确认新密码"></el-input>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbPwd=false">返回</div>
				<div class="b2" @click="memberupdateMemberPassword">确认修改</div>
			</div>
		</div>
		<!-- 提示框 添加员工 -->
		<div class="maskBg" @click="hbAddStaff=false" v-if="hbAddStaff"></div>
		<div class="subTipsTxt" v-if="hbAddStaff">
			<el-image class="cha" @click="hbAddStaff=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon101.png')"></el-image>
			<div class="t1">添加员工</div>
			<div class="t2">请员工到个人版注册个人账号，填写单位名称后自动匹配贵公司如需批量注册员工账号，请与我中心老师联系快速注册</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbAddStaff=false">返回员工管理</div>
			</div>
		</div>
		<!-- 弹出框 导入 -->
		<div class="maskBg" @click="hbExcel=false" v-if="hbExcel"></div>
		<div class="subTips" style="width: 6.62rem;" v-if="hbExcel">
			<div class="hbTit f-bct">
				<p>用户导入</p>
				<el-image class="cha" @click="hbExcel=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<el-upload accept="image/png, image/jpeg" 
			class="upload-demo"
			drag
			action="https://jsonplaceholder.typicode.com/posts/"
			multiple>
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
			<div class="tips f-bct"  slot="tip">
				<div class="t1">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
				<div class="t2">下载模板</div>
			</div>
			</el-upload>
			<div class="btnBox f-ct">
				<div class="b1">取消</div>
				<div class="b2">确定</div>
			</div>
		</div>
	</div>
</template>
<script>
import { membermemberList,
memberupdateMemberPassword
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbPwd:false,
			memberId:'',
			password:'',
			confirmPassword:'',
			hbAddStaff:false,
			hbExcel:false,
			value1:'',
			keword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			kpxxList:[],
		}
	},
	mounted() {
		this.membermemberList(1)
	},
	methods:{
		// 获取企业员工列表 列表
		async membermemberList(def){
			if(def){this.pageNum = 1}
			var data;
			if(this.value1){
				// data.pageNum = this.value1[0]
				// data.pageNum = this.value1[1]
				data = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					'params[beginTime]':this.value1[0],
					'params[endTime]':this.value1[1],
				}
			}else{
				data = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
			}
			
			if(this.keword){
				data.name = this.keword
			}
			
			const res = await membermemberList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.kpxxList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 修改会员密码
		async memberupdateMemberPassword(){
			const res = await memberupdateMemberPassword({
				confirmPassword:this.confirmPassword,
				password:this.password,
				memberId:this.memberId,
			});
			if(res.code==200){
				this.hbPwd = false
				this.Tips(res.msg,'success')
				this.memberInvoiceList(1)
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.membermemberList()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pageTit{
	border-bottom: 1px solid #DDDDDD;
	margin: 0 24px;
	padding-top: 24px;
	padding-bottom: 14px;
	span{
		font-size: 18px;
		color: #3B6492;
		font-weight: bold;
		position: relative;
		&::after{
			content: '';
			width: 100%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			position: absolute;
			bottom: -14px;
			left: 0;
		}
	}
}
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
	}
	.seachBtn{
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #3B6492;
				border: 1px solid #3B6492;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
	.seachBtn2{
		div{
			width: 148px;
			height: 46px;
			// border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #3B6492;
			text-align: center;
			line-height: 46px;
			background: #E9F6FF;
			cursor: pointer;
			border-radius: 6px;
			&:last-child{
				background: #3B6492;
				color: #fff;
				margin-left: 12px;
			}
		}
	}
}
.biaoge{
	padding: 24px;
	padding-top: 0;
	// background: #fff;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.t1{
			width: 95px;
		}
		.t2{
			width: 184px;
		}
		.t3{
			width: 142px;
		}
		.t4{
			width: 134px;
		}
		.t5{
			width: 300px;
		}
		.t6{
			width: 234px;
		}
		.t7{
			width: 210px;
		}
		.t8{
			width: 120px;
		}
		.t9{
			width: 100px;
		}
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 30px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 15px 10px;
				&:last-child{
					border: none;
				}
			}
			.blue{
				color: #3B6492;
				cursor: pointer;
			}
			.red{
				color: #FF5F5A;
				cursor: pointer;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 31px;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.nowpone{
		font-size: 16px;
		color: #3B6492;
		margin-bottom: 24px;
		text-align: center;
	}
	.upload-demo{
		width: 547px;
		// height: 270px;
		margin: auto;
		::v-deep .el-upload{
			width: 547px;
			height: 270px;
		}
		::v-deep .el-upload-dragger{
			width: 547px;
			height: 270px;
		}
		.el-icon-upload{
			margin-top: 80px;
		}
		.el-upload__text{
			margin-top: 10px;
			font-size: 16px;
		}
	}
	.tips{
		width: 547px;
		margin: auto;
		margin-top: 14px;
		.t1{
			font-size: 14px;
			color: #FF5F5A;
		}
		.t2{
			font-size: 14px;
			color: #3B6492;
		}
	}
	.iptBox{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		justify-content: center;
		.lable{
			font-size: 16px;
			color: #9A9DA7;
			margin-right: 30px;
		}
		.code{
			.el-input{
				width: calc(100% - 106px)!important;
			}
			.codeBtn{
				color: #3B6492;
				font-size: 16px;
				cursor: pointer;
			}
		}
		.ipt{
			width: 307px;
			height: 46px;
			border-radius: 8px;
			border: 1px solid #E8EDF4;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
		}
	}
	.btnBox{
		margin-top: 32px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.subTipsTxt{
	position: fixed;
	width: 500px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>